import { Plus, X } from "lucide-react";
import { FIELD_CLASS, LABEL_CLASS } from "./shared";

// Simple bullet-point feature list with inline editing and add/remove.
// `defaultsNote`/`onResetDefault` are optional — used by pages (like Wellside Canopies)
// where products can inherit a shared default list until an admin customizes it.
export const FeaturesSection = ({ form, newFeature, setNewFeature, addFeature, removeFeature, updateFeature, usingDefaultFeatures, onResetDefault, showNumbers }) => (
  <div>
    <div className="flex items-center justify-between">
      <span className={LABEL_CLASS}>Key Features</span>
      {onResetDefault && !usingDefaultFeatures && (
        <button type="button" data-testid="admin-features-reset-default" onClick={onResetDefault} className="text-xs font-mono text-white/50 hover:text-[var(--brand-primary)] underline">
          Reset to shared defaults
        </button>
      )}
    </div>
    {onResetDefault && usingDefaultFeatures && (
      <p data-testid="admin-features-default-note" className="text-white/40 text-xs mt-1 italic">
        Showing the default feature list shared by all canopies (this product has no custom list yet). Editing below will save a custom list just for this product.
      </p>
    )}
    <ul className="mt-2 space-y-2">
      {form.features.map((f, i) => (
        <li key={i} data-testid={`admin-feature-${i}`} className="flex items-center gap-2 text-white/80 text-sm">
          {showNumbers && (
            <span data-testid={`admin-feature-number-${i}`} className="text-white/40 text-xs font-mono w-5 shrink-0 text-right">
              {i + 1}.
            </span>
          )}
          <input
            data-testid={`admin-feature-edit-${i}`}
            value={f}
            onChange={(e) => updateFeature(i, e.target.value)}
            className={FIELD_CLASS + " mt-0 flex-1"}
          />
          <button type="button" onClick={() => removeFeature(i)} data-testid={`admin-feature-remove-${i}`} className="text-white/50 hover:text-red-400 shrink-0">
            <X size={14} />
          </button>
        </li>
      ))}
    </ul>
    <div className="flex gap-2 mt-2">
      <input
        data-testid="admin-feature-input"
        value={newFeature}
        onChange={(e) => setNewFeature(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addFeature(); } }}
        className={FIELD_CLASS + " mt-0"}
        placeholder="Add a feature bullet…"
      />
      <button type="button" onClick={addFeature} data-testid="admin-feature-add" className="btn-secondary shrink-0">
        <Plus size={14} />
      </button>
    </div>
  </div>
);
